module.exports = __webpack_public_path__ + "static/media/accuracy.875a9020.png";